import { AUTH_COOKIES } from '@libs/core';
import Cookies from 'js-cookie';

export const getAccessToken = () => Cookies.get(AUTH_COOKIES.ACCESS_TOKEN);

export const getRefreshToken = () => Cookies.get(AUTH_COOKIES.REFRESH_TOKEN);

export const getAnonymousIdToken = () =>
    Cookies.get(AUTH_COOKIES.PETM_ANONYMOUS_KEY);

export const setAnonymousIdToken = (anonId: string) =>
    Cookies.set(AUTH_COOKIES.PETM_ANONYMOUS_KEY, anonId);
